import { ParceiroApi } from "@/api/facturacao/ParceiroApi";

export class FornecedorApi extends ParceiroApi {
  protected readonly grupo = "Fornecedor" as const;
}
